import React from 'react';

/**
 * The Clutch mark, drawn to sit beside lucide's `Linkedin` in the footer.
 *
 * Clutch ships a red-and-black logo, but next to a monochrome icon row that
 * would read as a stray graphic rather than a social link. So this is the
 * shape only -- the open ring and the centre dot -- in `currentColor`, on
 * lucide's 24x24 grid and 2px stroke, so it inherits the same colour and hover
 * as its neighbour and lines up at any size.
 */
export function ClutchIcon({
  className,
  ...rest
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      className={className}
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <path d="M17.9 6.6a8 8 0 1 0 0 10.8" />
      <circle cx="12" cy="12" r="2.9" fill="currentColor" stroke="none" />
    </svg>
  );
}
